/* eslint-disable array-callback-return, consistent-return */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Insert from '../post/content/insert';
import Ad from '../ad/ad';
import FiniteScrollTopStories from './top_stories';
// import Newsletter from './newsletter';
import RelatedStories from './related_stories';
import Dianomi from '../dianomi/dianomi_script';
import RecommendedArticles from './recommended_articles';
import { get, isEmpty, isUndefined } from 'lodash';
import axios from 'axios';

const FiniteScroll = ({
  post,
  secondScrollPost,
  adModels,
  config,
  options
}) => {
  const [articles, setArticles] = useState(null);

  useEffect(() => {
    const apikey = 'fastcompany.com';
    const secret = 'Ldqx1NBhAHGqsuzIEaGqfzdmrnojHLYPoCdw4ISeZxU';
    const url = `https://api.parsely.com/v2/referrers/social/posts?apikey=${apikey}&secret=${secret}&domain=twitter.com&period_start=7d&limit=100`;

    axios(url).then(res => {
      const feed = res.data.data
        .filter(article => {
          let ok = true;

          const section = get(article, 'section', '');
          if (section === 'advertorial') ok = false;
          if (isUndefined(window.recircArticles) && section !== 'advertorial')
            return article;

          window.recircArticles.map(re => {
            if (article.url === re.url) {
              ok = false;
            }
          });

          if (ok) return article;
        })
        .slice(0, 35);

      setArticles(feed);
    });
  }, []);

  if (!articles) return false;

  return (
    <section className="finite-scroll-experience">
      {!isEmpty(secondScrollPost) && (
        <Insert
          key="insert_1"
          config={config}
          tags={get(secondScrollPost, 'tags', [])}
          postData={secondScrollPost}
          insert={true}
          pageNum={0}
          related={get(options, 'related', [])}
          combinedAdModel={get(adModels, 'secondScrollPost', {})}
          videoAdData={get(adModels, 'secondScrollVideo', {})}
          updateCorrelator={true}
          live={false}
          isDesktop={get(options, 'sticky', false)}
          mic2020Companies={get(options, 'mic2020Companies', [])}
          mic2020Regions={get(options, 'mic2020Regions', [])}
          mic2020Sectors={get(options, 'mic2020Sectors', [])}
          postPromoterArticleText={get(options, 'postPromoterArticleText', '')}
          event={get(options, 'event', '')}
          isFiniteExperience={true}
        />
      )}

      <div className="post post--default">
        <div className="post__main">
          <div className="post__body">
            <div className="post__container post__container--long">
              <div className="post__content">
                <FiniteScrollTopStories articles={articles.slice(0, 5)} />
                {/* <Newsletter {...config} /> */}
                <RelatedStories />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Dianomi
        initialPageLoad={get(config, 'initialPageLoad', false)}
        site={get(config, 'site', 'fastcompany')}
        postNativeAd={get(options, 'postNativeAd', {})}
        config={config}
      />

      <div className="post__article-top-ad-wrapper">
        <Ad
          {...get(adModels, 'combined')}
          name="flexiblebillboard"
          region="articlescroll"
          ceros={false}
          pos="btf"
        />
        <Ad
          {...get(adModels, 'combined')}
          name="mobileleaderboard"
          region="articlescroll"
          pos="btf"
        />
      </div>

      <RecommendedArticles
        config={config}
        post={post}
        adSplit={15}
        combinedAdModel={get(adModels, 'combined')}
        articles={articles.slice(6)}
      />
    </section>
  );
};

FiniteScroll.propTypes = {
  post: PropTypes.shape({}).isRequired,
  articles: PropTypes.shape([]),
  secondScrollPost: PropTypes.shape({}),
  abGroup: PropTypes.number,
  adModels: PropTypes.shape({
    combined: PropTypes.shape({}).isRequired,
    secondScrollPost: PropTypes.shape({}),
    secondScrollVideo: PropTypes.shape({})
  }).isRequired,
  config: PropTypes.shape({}).isRequired,
  options: PropTypes.shape({}).isRequired
};

FiniteScroll.defaultProps = {
  secondScrollPost: {},
  articles: null,
  abGroup: 0
};

export default FiniteScroll;
